import React, { Component } from 'react'
import Linkedin from './icon_in.svg'
import FaceBook from './icon_fb.svg'
import Wechat from './icon_wechat.svg'
import Mail from './icon_mail.svg'
import HomeAboutQR from '../home/HomeAboutQR'

export default class AboutLeft extends Component {

    state = { isQR : false }


    closeFx = () => {

        this.setState(
            { isQR : false }
        )
    }

    openFx = () => {

        this.setState(
            { isQR : true }
        )
    }

    render() {


        return (

            <div id='AboutLeft'>

                { this.state.isQR ? <HomeAboutQR closeMe={this.closeFx} /> : null }

                <div id='AboutIntro'>

                    <span id='AboutHello'>
                    I enjoy making something with my own hand. I am thrilled with the result that I made.
                    But most times, the journey to build something was much tougher than I expected.
                    Fortunately, there were many gurus who guided me.
                    If you are a guy like me, and if there's something that I can help, please contact me.
                    </span>

                    <h3 className='AboutTitle'>Career</h3>
                    
                    <p><strong>LG CNS Co.,Ltd. </strong><span> (Aug 2019 - Current)</span></p>
                    <span>Business Engineering Professional | Global Ecommerce Project</span>

                    <p>&nbsp;</p>

                    <p><strong>YG-1 Co.,Ltd. </strong><span> (Sep 2014 - Aug 2019)</span></p>
                    <span>Deputy General Manager | Global Ecommerce Team Leader</span>

                    <p>&nbsp;</p>

                    <p><strong>Chance House Co.,Ltd. </strong><span> (Mar 2008 - Aug 2014)</span></p>
                    <span>Founder and CEO | Global Ecommerce, Import, Export</span>

                    <p>&nbsp;</p>

                    <p><strong>LG Electronics Inc. </strong><span> (Feb 2003 - Feb 2008)</span></p>
                    <span>Assistant Manager | DID (Digital Information Display) B2B Sales</span>

                    <h3 className='AboutTitle'>Education</h3>
                    
                    <p><strong>Hankuk University of Foreign Studies </strong><span> (1995 - 2003)</span></p>
                    <span>Bachelor of Arts | Japanese</span>

                    <p>&nbsp;</p>

                    <p><strong>Kwachon Foreign Language High School </strong><span> (1992 - 1995)</span></p>
                    <span>Departments of Japanese</span>

                    <h3 className='AboutTitle'>Skills and Certification</h3>

                    <p><strong>Ecommerce Platform</strong></p>
                    <span>Magento Certified Solution Specialist</span>

                    <p>&nbsp;</p>

                    <p><strong>Computer Languages</strong></p>
                    <span>ECMA Script, React, Node.js, MongoDB, CSS, HTML and more</span>

                    <p>&nbsp;</p>

                    <p><strong>Human Languages</strong></p>
                    <span>Korean, English (TOEIC 885pts.), Japanese (JLPT Lvl.1), Chinese (HSK Lvl.5)</span>

                    <p>&nbsp;</p>

                    <p><strong>Other</strong></p>
                    <span>SEO (Google, Baidu), CPC (Google, Baidu, Naver), Photoshop, Illustrator</span>

					<div id='AboutSns'>

                        <a href='https://www.linkedin.com/in/chancehouse/'>
                            <img src={Linkedin} alt='LinkedIn' />
                        </a>

                        <a href='https://www.facebook.com/redcomma'>
                            <img src={FaceBook} alt='FaceBook' />
                        </a>

                        <img src={Wechat} onClick={this.openFx} alt='WeChat' />

                        <a href='mailto:ryuwoosil@gmail.com'>
                            <img src={Mail} alt='email' />
                        </a>

                    </div>

                </div>

            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/about/AboutLeft.js